<!-- Center canvas: summary, text typed into directly - whole card is one pinnable region -->
<div class="cr-zn-card" *ngIf="isPreview" [id]="block.blockId">
  <span class="cr-zn-badge">ZigZag No Heading + No Button</span>

  <div class="cr-zn-row">
    <div
      class="cr-zn-dropzone"
      [appInlineMedia]="block.variables?.['ZigZagNhnbImage']"
      [inlineMediaBlockId]="block.blockId"
      (inlineMediaChange)="onChange($event, 'ZigZagNhnbImage')"
    >
      <a *ngIf="block.variables?.['ZigZagNhnbImage']; else emptyPreview" [href]="imagePreviewHref" target="_blank" rel="noopener">
        <img [src]="block.variables?.['ZigZagNhnbImage']" [alt]="block.variables?.['ZigZagNhnbImageAlt'] || ''" />
      </a>

      <ng-template #emptyPreview>
        <div class="cr-inline-media-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-inline-media-title">Upload image</div>
        <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
      </ng-template>
    </div>

    <span
      class="cr-zn-text"
      [appInlineEdit]="block.variables?.ZigZagNhnbText ?? ''"
      [inlineEditBlockId]="block.blockId"
      inlineEditPlaceholder="Insert row text"
      [inlineEditMultiline]="true"
      (inlineEditChange)="onChange($event, 'ZigZagNhnbText')"
    ></span>
  </div>
</div>

<!-- Right panel: real edit form -->
<div class="cr-zn-edit" *ngIf="!isPreview">
  <div class="cr-zn-field-row">
    <span class="cr-zn-field-label">Image</span>
    <span
      class="cr-zn-toggle"
      [class.cr-zn-toggle-on]="imageAsUpload"
      role="button"
      tabindex="0"
      [title]="imageAsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleImageMode()"
      (keydown.enter)="toggleImageMode()"
      (keydown.space)="toggleImageMode()"
    ></span>
  </div>
  <div class="cr-zn-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['ZigZagNhnbImage'] ?? ''"
      (handleOnChange)="onChange($event, 'ZigZagNhnbImage')"
      [placeholder]="imagePlaceholder"
      variable="ZigZagNhnbImage"
      [isImage]="imageAsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-zn-empty-overlay" *ngIf="imageAsUpload && !block.variables?.['ZigZagNhnbImage']">
      <div class="cr-zn-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-zn-title">Upload image</div>
      <div class="cr-zn-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-zn-link-field">
    <app-field-editor-v2
      [maxLength]="500"
      type="action-link"
      [blockData]="block.variables?.['ZigZagNhnbImageHref'] ?? ''"
      (handleOnChange)="onChange($event, 'ZigZagNhnbImageHref')"
      [placeholder]="imageHrefPlaceholder"
      variable="ZigZagNhnbImageHref"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'ZigZagNhnbImageHrefSegmentRegex')"
      [selectedSegment]="block.variables?.['ZigZagNhnbImageHrefSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="alt"
    [blockData]="block.variables?.['ZigZagNhnbImageAlt'] ?? ''"
    (handleOnChange)="onChange($event, 'ZigZagNhnbImageAlt')"
    [placeholder]="imageAltPlaceholder"
    [maxLength]="500"
    variable="ZigZagNhnbImageAlt"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [multiline]="true"
    [showCounter]="true"
    [blockData]="block.variables?.['ZigZagNhnbText'] ?? ''"
    (handleOnChange)="onChange($event, 'ZigZagNhnbText')"
    [placeholder]="textPlaceholder"
    [maxLength]="4000"
    variable="ZigZagNhnbText"
    [disabled]="disabled"
  ></app-field-editor-v2>
</div>
